import { useContext, useState } from 'react';
import { Signal } from '@styled-icons/fa-solid';
import copyIcon from '../../images/copyIcon.png';
import { getHeaderValues } from './QAChecklistTab/utils';
import { StoreContext } from '../Store';
import ConfirmationModal from '../ConfirmationModal';

const BILL_TYPES = {
  10: 'Headers',
  20: 'Rows',
};

const LoadConfirmation = ({
  newLoadAction,
  listLoadAction,
  statusAction,
  titleText,
  bodyText,
  portalRef,
  isSubmitted,
  products,
  billableType = 20,
  setShowIpaffsModal,
}) => {
  const store = useContext(StoreContext);

  const [buttonText, setButtonText] = useState('Copy Ref');
  const isEPO = portalRef?.includes('EPO');

  const handleCopyRef = () => {
    navigator.clipboard.writeText(portalRef);
    setButtonText('Copied');
  };

  return (
    <div className="p-4 d-flex flex-column align-items-center " style={{ marginTop: '4rem', marginRight: '4rem' }}>
      <h1 style={{ color: '#fff' }}>{titleText}</h1>
      <div className="tick-success-large" style={{ marginTop: '0.2rem', marginBottom: '1rem' }}></div>
      <p style={{ fontSize: '110%', color: '#fff' }}>{`${portalRef || ''} ${bodyText}`}</p>

      {isSubmitted && (
        <p style={{ fontSize: '110%', color: '#fff', fontWeight: 'bold' }}>
          Number of {BILL_TYPES[billableType]}: {billableType === '10' ? getHeaderValues(products) : products.length}
        </p>
      )}

      <div className="gap-3 d-flex mb-3">
        <button onClick={handleCopyRef} className="btn_submitted_copy_ref">
          <img src={copyIcon} alt="copy icon" />
          <p>{buttonText}</p>
        </button>
        {isSubmitted && statusAction && (
          <button onClick={statusAction} className="btn_submitted_copy_ref">
            <Signal width="20" height="20" style={{ color: '#fff', marginTop: '6px' }} />
            <p>Status</p>
          </button>
        )}
      </div>
      <div className="gap-3 d-flex ">
        {!isEPO && (
          <button className="blue-button-newload" style={{ width: 'auto' }} onClick={newLoadAction}>
            New Load
          </button>
        )}
        <button className="blue-button-newload" style={{ width: 'auto' }} onClick={listLoadAction}>
          List Loads
        </button>

        {titleText.includes('Saved as') && (
          <button className="blue-button-newload" style={{ width: 'auto' }} onClick={() => setShowIpaffsModal(true)}>
            Check IPAFFS
          </button>
        )}
      </div>
      <ConfirmationModal
        header="An error occurred"
        show={store.automaticRpaUploadFailed[0]}
        onHide={() => store.automaticRpaUploadFailed[1](false)}
        hideConfirm
      >
        Failed to upload RPA to load Document(s). Please try again manually.
      </ConfirmationModal>
    </div>
  );
};

export default LoadConfirmation;
